import { Archive, Unarchive } from '@project-lary/react-material-symbols-400-rounded';
import { useCurrentUserToggleArchivedChannelMutation } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import IconButton from 'gcs-common/design-system/ui/icon-button';
import { getIsHidden } from 'gcs-common/slices/channel/channelSelectors';
import { useSelector } from 'react-redux';

const ChannelArchiveButton = ({ selectedChannelId }: { selectedChannelId: string }) => {
  const isHidden = useSelector(getIsHidden(selectedChannelId));
  const toggleArchiveChannelMutation = useCurrentUserToggleArchivedChannelMutation();

  async function onChannelVisibilityButtonClick() {
    await toggleArchiveChannelMutation.mutateAsync({
      channelId: selectedChannelId,
    });
  }

  const icon = isHidden ? Unarchive : Archive;

  return (
    <IconButton
      Icon={icon}
      onClick={onChannelVisibilityButtonClick}
      iconSize="size-6"
      className="cursor-pointer"
      size="m"
      variant="ghost_neutral"
      disabled={toggleArchiveChannelMutation.isPending}
    />
  );
};

export default ChannelArchiveButton;
